const React = require('react');
const utils = require('utils/utils');
const router = require('utils/router');
const LoginForm = require('views/login/login-form');
const MudarSenha = require('views/login/mudar-senha');
const Home = require('views/home/home');
const api = require('utils/api-controller');
const messageCtrl = require('utils/message-controller');
const Alert = require('components/alert');
const toastService = require('utils/toast-service');
const ajaxIndicator = require('utils/ajax-indicator');
const dialog = require('utils/modal-service');
import moment from 'moment';
import logoImg from '../img/logo_alpha.png';

var routes = {};


const Footer = (props) => {
	return (
		<div className="container page-footer">
      <img src={logoImg} className="footer-logo" />
			<span className="footer-text">Desenvolvido por Alpha Softworks T.I.</span>
    </div>
	);
};

module.exports = React.createClass({
	
	mixins: [ dialog.mixin, router.mixin, api.mixin, messageCtrl.mixin, toastService.mixin, ajaxIndicator.mixin ],

	renderAlert(){

		var style = {};
		var className = '';

		if (messageCtrl.message) {
			style.display = 'block';
			className = messageCtrl.messageType + ' animated fadeInRight';
		} else {
			className = 'animated fadeOutLeft';
			style.display = 'none';
		}
		
		return (
			<Alert className={className} style={style} onClose={messageCtrl.clearMessage}>
			  {messageCtrl.message}
            </Alert>
        );
	},

	render(){
	
		var content;

		if (!api.isAuthenticated()) {
      content = <LoginForm />;
    } else if (api.profile.statusSenha == '2' || router.getWithoutParams() == 'mudarsenha') {
      content = <MudarSenha />;
    } else {
      content = <Home />;
		}

		var ajaxDiv;
		if (this.isAjaxRunning()) {
			ajaxDiv = (
				<div>
					<div className='ajax-box'>Aguarde, aguardando resposta servidor ...</div>
				</div>
			);
		}

		return (
			<div className="view-container">
				{ajaxDiv}
				{this.renderToasts()}
				{this.renderAlert()}

				<div>
          {content}
					<Footer />
				</div>
				{this.renderModals()}
			</div>
		);
	}
});


if (api.isResettingPass()) {
  var token = window.resetPass;
  api.decodeJwt(token);
}

window.systemName = window.systemName || 'Nome do Sistema';
moment.locale("pt-BR");


/** WEBPACK FOOTER **
 ** ./src/app.js
 **/